<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :definition="{}"
    :generate-summary="() => {}"
    :caption="caption"
    :disabled="true"
    :allow-actions="false"
    :allow-delete="false"
    parent-id-filter-field="productID"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="() => {}"
    :create-form-data-from-item="() => {}"
    permission-code="Stock"
    :show-summary-row="true"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import { entityToStore } from '@/utils/store';

export default {
  components: {
    EmbeddedCrudTable
  },
  props: {
    caption: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    entity: 'Stock'
  }),
  computed: {
    entityStore() {
      return entityToStore(this.entity);
    },
    columns() {
      return [
        { field: 'stockLocationName', label: 'stock.stockLocationName' },
        {
          field: 'availableQuantityInMeters',
          label: 'stock.stockAvailable',
          filter: { type: 'checkbox', label: 'stock.onlyShowFabricsWithAvailableStock' }
        },
        { field: 'reservedQuantityInMeters', label: 'stock.stockReserved', filter: { type: 'none' } },
        { field: 'soldQuantityInMeters', label: 'stock.stockSold', filter: { type: 'none' } },
        { field: 'blockedQuantityInMeters', label: 'stock.stockBlocked', filter: { type: 'none' } }
      ];
    }
  }
};
</script>

<style lang="scss" scoped></style>
